import React, { useState, useRef, useEffect } from 'react'
import "../hamcss/career.css"
import careerBanner from '../assests/career/career.webp';
import Navbar from './Navbar';
import Footer from './Footer';

import employee from "../assests/icons/careerIcon/employee.png"
import role from "../assests/icons/careerIcon/role.png"
import work from "../assests/icons/careerIcon/work.png"
import growth from "../assests/icons/careerIcon/growth.png"
import team from "../assests/icons/careerIcon/team.png"
import competitive from "../assests/icons/careerIcon/cooperation.png"
import development from "../assests/icons/careerIcon/development.png"
import reward from "../assests/icons/careerIcon/reward.png"
import culture from "../assests/icons/careerIcon/ethical.png"

import review from "../assests/icons/careerIcon/review.png"
import hr from "../assests/icons/careerIcon/hr.png"
import interview from "../assests/icons/careerIcon/interview.png"
import decision from "../assests/icons/careerIcon/decision.png"

import img1 from "../assests/career/emp1.jpg";
import img2 from "../assests/career/emp2.jpg";
import img3 from "../assests/career/emp3.jpg";
import img4 from "../assests/career/emp4.jpg";
import img5 from "../assests/career/emp5.jpg";
import img6 from "../assests/career/emp6.jpg";
import img7 from "../assests/career/emp7.jpg";
import img8 from "../assests/career/emp8.jpg";

import emp1 from "../assests/career/Anamika Gusain.png";
import emp2 from "../assests/career/Anshul Manchanda.jpeg";
import emp3 from "../assests/career/Madhusmita Chauhan.jpeg";

import sgimage from "../assests/career/sgimage.png"

import DotRing from '../component/dot/DotRing';
import { Link } from 'react-router-dom';
// import au from '../assests/Team/abhishek mahajan.png';

const Careers = () => {

    const sliderRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const images = [img1, img2, img3, img4, img5, img6, img7, img8];

    /* ---------- SLIDER SCROLL ---------- */
    const scroll = (direction) => {
        sliderRef.current.scrollBy({
            left: direction === "left" ? -320 : 320,
            behavior: "smooth",
        });
    };

    /* ---------- LOCK BODY SCROLL ---------- */
    useEffect(() => {
        document.body.style.overflow = selectedImage ? "hidden" : "auto";
    }, [selectedImage]);


    const [index, setIndex] = useState(0);

    const testimonials = [
        {
            img: emp2,
            text:
                "SG Finserve Limited offers a professional and growth-oriented work environment with strong compliance and well-defined credit administration processes. My overall experience has been highly rewarding, providing exposure to end-to-end credit operations, process building, team leadership, and regulatory compliance. The organization’s collaborative culture and customer-centric approach make it a trusted and dependable financial partner.",
            name: "Anshul Manchanda",
            role: "Chief Manager - Operations",
        },
        {
            img: emp3,
            text:
                "I have been working at SG Finserve for the past two years in the customer support team. My journey so far has been smooth and enriching. The people here are always supportive. At the same time, everyone is highly passionate and dedicated to their work.",
            name: "Madhusmita Chauhan",
            role: "Manager – Customer Service",
        },
        {
            img: emp1,
            text:
                "Having almost 8 years of experience, including SG Finserve, HDFC, and IndusInd Bank, my journey has been truly rewarding. Working with the SG family has been wonderful, and I’m grateful to a mentor who always supported and encouraged my growth.",
            name: "Ambika Gusain",
            role: "Senior Manager",
        },
    ];

    /* ---------- AUTO SLIDE ---------- */
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % testimonials.length);
        }, 4500);

        return () => clearInterval(interval);
    }, [testimonials.length]);

    /* ---------- MOBILE SWIPE ---------- */
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current - touchEndX.current > 50) {
            nextSlide();
        }

        if (touchEndX.current - touchStartX.current > 50) {
            prevSlide();
        }
    };

    /* ---------- ARROW ACTIONS ---------- */
    const nextSlide = () => {
        setIndex((prev) => (prev + 1) % testimonials.length);
    };

    const prevSlide = () => {
        setIndex((prev) =>
            prev === 0 ? testimonials.length - 1 : prev - 1
        );
    };


    return (
        <>
            <section style={{ justifyContent: 'center' }}>
                <section className="containner">
                    <DotRing />

                    <Navbar />
                    <div>
                        <div className="BreadArea" style={{
                            backgroundImage: `url(${careerBanner})`,
                        }}>
                            <div
                                className="container">
                                <h2>Career</h2>
                            </div>
                        </div>
                    </div>

                    <section className="careers-section">
                        <div className="careers-container">
                            <h1 className="careers-title">Careers @ SG finserve</h1>

                            <p className="careers-description">
                                SG finserve Services Ltd is a trusted NBFC in India, focused on delivering customized and flexible growth capital solutions for SMEs and corporates, helping businesses navigate credit challenges and accelerate their growth journey.
                            </p>

                            <button className="careers-btn">Explore Roles</button>
                        </div>
                    </section>


                    {/* join section */}
                    <section className="why-join-section">
                        <div className="why-join-container">
                            <h1 className="careers-title">Why join SG finserve?</h1>
                            <p className="why-join-subtitle">
                                Be a part of a growing financial institution where your work creates real impact
                            </p>

                            <div className="why-join-card">
                                <div className="why-join-grid">
                                    <div className="why-join-item">
                                        <img src={employee} alt="" />
                                        Employee Growth
                                    </div>

                                    <div className="why-join-item">
                                        <img src={role} alt="" />
                                        Impact Roles
                                    </div>

                                    <div className="why-join-item">
                                        <img src={work} alt="" />
                                        Work Culture
                                    </div>

                                    <div className="why-join-item">
                                        <img src={growth} alt="" />
                                        Fast Growth
                                    </div>

                                    <div className="why-join-item">
                                        <img src={team} alt="" />
                                        Strong Teams
                                    </div>

                                    <div className="why-join-item">
                                        <img src={competitive} alt="" />
                                        Competitive Pay
                                    </div>

                                    <div className="why-join-item">
                                        <img src={development} alt="" />
                                        Skill Development
                                    </div>

                                    <div className="why-join-item">
                                        <img src={reward} alt="" />
                                        Performance Rewards
                                    </div>

                                    <div className="why-join-item">
                                        <img src={culture} alt="" />
                                        Ethical Culture
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>



                    {/* how we hire */}
                    <section className="how-hire-section">
                        <div className="how-hire-container">
                            <h2 className="careers-title">How we hire at SG finserve?</h2>
                            <p className="how-hire-subtitle">
                                A transparent and structured hiring journey
                            </p>

                            <div className="how-hire-grid">
                                {/* Card 1 */}
                                <div className="how-hire-card">
                                    <span className="hire-step">1</span>
                                    <div className="hire-icon"><img src={review} alt="application review" /></div>
                                    <h3>Application Review</h3>
                                    <p>
                                        Once we receive your application, our recruitment team carefully
                                        reviews your profile against the role requirements and business needs.
                                    </p>
                                </div>

                                {/* Card 2 */}
                                <div className="how-hire-card">
                                    <span className="hire-step">2</span>
                                    <div className="hire-icon"><img src={hr} alt="hr connect" /></div>
                                    <h3>HR Connect</h3>
                                    <p>
                                        Shortlisted candidates are contacted by our HR team for an initial
                                        discussion within 7 working days. For follow-ups, you may write to{" "}
                                        <a href="mailto:career@sgfinserve.com">career@sgfinserve.com</a>.
                                    </p>
                                </div>

                                {/* Card 3 */}
                                <div className="how-hire-card">
                                    <span className="hire-step">3</span>
                                    <div className="hire-icon"><img src={interview} alt="interview process" /></div>
                                    <h3>Interview Process</h3>
                                    <p>
                                        Candidates who clear the HR discussion move forward to interviews
                                        with hiring managers, conducted virtually or in person as required.
                                    </p>
                                </div>

                                {/* Card 4 */}
                                <div className="how-hire-card">
                                    <span className="hire-step">4</span>
                                    <div className="hire-icon"><img src={decision} alt="final decision" /></div>
                                    <h3>Final Decision</h3>
                                    <p>
                                        Based on overall performance and role alignment, successful candidates
                                        receive an offer, while others are duly informed about the outcome.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>


                    {/*<section className="life-section">
                        <div className="life-container">
                            <h2 className="careers-title">Life @ SG finserve</h2>
                            <p className="life-subtitle">
                                Take a visual walk through our vibrant and joyful work environment
                            </p>

                            <div className="life-slider-wrapper">
                                <button
                                    className="slider-btn left"
                                    onClick={() => scroll("left")}
                                >
                                    ‹
                                </button>

                                <div className="life-slider" ref={sliderRef}>
                                    {images.map((img, i) => (
                                        <img
                                            key={i}
                                            src={img}
                                            alt="Life at SG Finserve"
                                            onClick={() => setSelectedImage(img)}
                                        />
                                    ))}
                                </div>

                                <button
                                    className="slider-btn right"
                                    onClick={() => scroll("right")}
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    </section>*/}

                    {/* ---------- FULLSCREEN IMAGE VIEWER ---------- */}
                    {selectedImage && (
                        <div className="image-viewer" onClick={() => setSelectedImage(null)}>
                            <span className="close-viewer">&times;</span>
                            <img src={selectedImage} alt="Full View" />
                        </div>
                    )}


                    {/* testomonial section  */}
                    <section className="testimonial-section">
                        <h2 className="careers-title">Employee Testimonials</h2>
                        <p className="testimonial-subtitle">
                            Hear directly from our team about life at SG finserve
                        </p>

                        <div className="testimonial-wrapper">

                            <button
                                className="testimonial-arrow left"
                                onClick={prevSlide}
                                aria-label="Previous"
                            >
                                &#10094;
                            </button>


                            <div
                                className="testimonial-card"
                                onTouchStart={handleTouchStart}
                                onTouchMove={handleTouchMove}
                                onTouchEnd={handleTouchEnd}
                            >
                                <div className="testimonial-image">
                                    <img
                                        src={testimonials[index].img}
                                        alt={testimonials[index].name}
                                    />
                                </div>

                                <div className="testimonial-content">
                                    <p className="testimonial-text">
                                        {testimonials[index].text}
                                    </p>
                                    <h4>{testimonials[index].name}</h4>
                                    <span>{testimonials[index].role}</span>
                                </div>
                            </div>


                            <button
                                className="testimonial-arrow right"
                                onClick={nextSlide}
                                aria-label="Next"
                            >
                                &#10095;
                            </button>
                        </div>


                        <div className="testimonial-dots">
                            {testimonials.map((_, i) => (
                                <span
                                    key={i}
                                    className={`dot ${i === index ? "active" : ""}`}
                                ></span>
                            ))}
                        </div>
                    </section>


                    <section className="career-cta-wrapper">
                        <div className="career-cta-card">

                            {/* LEFT CONTENT */}
                            <div className="career-cta-content">
                                <h2>Excited about our company?</h2>
                                <p>
                                    Explore the roles we're hiring for and find your perfect fit with us
                                </p>

                                <button className="career-cta-btn">
                                    Explore Roles
                                </button>
                            </div>

                            {/* RIGHT IMAGE */}
                            <div className="career-cta-image">
                                <img
                                    src={sgimage}
                                    alt="Explore Roles"
                                />
                            </div>

                        </div>
                    </section>

                    <Footer />
                </section>
            </section>
        </>
    )
}

export default Careers